import React from 'react';

const ClockIcon = ({ color }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3482_7890)">
        <path
          d="M8 0C6.41775 0 4.87103 0.469192 3.55544 1.34824C2.23984 2.22729 1.21446 3.47672 0.608964 4.93853C0.00346247 6.40034 -0.154964 8.00887 0.153718 9.56072C0.462399 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87897 15.1541 3.84547 13.6543 2.34568C12.1545 0.845886 10.121 0.00229405 8 0V0ZM8 14.6667C6.68146 14.6667 5.39253 14.2757 4.2962 13.5431C3.19987 12.8106 2.34539 11.7694 1.8408 10.5512C1.33622 9.33305 1.2042 7.99261 1.46143 6.6994C1.71867 5.40619 2.3536 4.21831 3.28595 3.28596C4.2183 2.35361 5.40619 1.71867 6.6994 1.46143C7.9926 1.2042 9.33305 1.33622 10.5512 1.8408C11.7694 2.34539 12.8106 3.19987 13.5431 4.2962C14.2757 5.39253 14.6667 6.68146 14.6667 8C14.6647 9.76752 13.9617 11.4621 12.7119 12.7119C11.4621 13.9617 9.76751 14.6647 8 14.6667Z"
          fill="#6D6D6D"
        />
        <path
          d="M7.99989 4C7.82308 4 7.65351 4.07024 7.52849 4.19526C7.40347 4.32029 7.33323 4.48985 7.33323 4.66667V7.54999L5.08589 8.95799C4.93561 9.05188 4.82877 9.20162 4.78888 9.37428C4.749 9.54694 4.77934 9.72837 4.87323 9.87866C4.96711 10.0289 5.11686 10.1358 5.28952 10.1757C5.46217 10.2155 5.6436 10.1852 5.79389 10.0913L8.35389 8.49133C8.45062 8.43072 8.53016 8.3463 8.58491 8.24615C8.63965 8.14599 8.66777 8.03346 8.66656 7.91933V4.66667C8.66656 4.48985 8.59632 4.32029 8.4713 4.19526C8.34627 4.07024 8.1767 4 7.99989 4Z"
          fill="#6D6D6D"
        />
      </g>
      <defs>
        <clipPath id="clip0_3482_7890">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ClockIcon;
